/* eslint-disable camelcase */
export default {
  info_popup: 'Дополнительная информация',
  link: 'Показать на визуальном дереве',
};
